import React, { useState, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { gql, useMutation } from '@apollo/client';

const REFRESH_TOKEN = gql`
  mutation Refresh($refreshToken: String!) {
    refreshToken(token: $refreshToken) {
      success
      token
      refreshToken
    }
  }
`;

export default function PrivateRoute() {
  const [loading, setLoading] = useState(true);
  const [ok, setOk] = useState(false);
  const [refresh] = useMutation(REFRESH_TOKEN);

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem('token');
      const refreshToken = localStorage.getItem('refreshToken');
      if (token) {
        try {
          const { exp } = jwtDecode(token);
          if (exp * 1000 > Date.now()) {
            setOk(true); return;
          }
        } catch {}
      }
      // токен отсутствует или истёк
      if (refreshToken) {
        try {
          const { data } = await refresh({ variables: { refreshToken } });
          if (data.refreshToken.success) {
            localStorage.setItem('token', data.refreshToken.token);
            localStorage.setItem('refreshToken', data.refreshToken.refreshToken);
            setOk(true);
            return;
          }
        } catch {}
      }
      setOk(false);
    })().finally(() => setLoading(false));
  }, [refresh]);

  if (loading) return null;         // или спиннер
  if (!ok)     return <Navigate to="/login" replace />;
  return <Outlet />;               // рендерим вложенные маршруты
}